import { CcfBox, useTranslator } from '@nice-ccf/ui-controls';
import styles from './ccf-wem-dashboard.module.scss';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';

import { MenuItem, Select } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWemTableProps {
  columns: any;
  tableHeaderText?: string;
  noDataFound?: any;
  rowData: any;
  isSelectRequired?: boolean;
}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: 'none',
      height: '100%',
    },
    '& .MuiDataGrid-columnHeaderWrapper': {
      height: '36px',
    },
    '& .MuiDataGrid-columnHeaders': {
      border: '1px solid #d2d8db',
      borderRadius: '0px',
    },
    '& .MuiDataGrid-virtualScrollerContent': {
      height: '1px !important',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526b7a',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',
      color: '#333333',
    },
  },
  searchInput: {
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
});

/**
 * CcfWemTable - used to display wem DataGrid Table
 * @param props - CcfWemTable
 * @example `<CcfWemTable />`
 */
export function CcfWemTable(props: CcfWemTableProps) {
  const classes = useStyles();
  const [translate] = useTranslator();
  const [rowData, setRowData]: any = useState([]);
  const [dropdownData, setDropdownData] = useState(translate('last30days'));
  useEffect(() => {
    setRowData(props.rowData);
  }, [props.rowData]);
  /**
   * Handles the change event for input elements.
   * Updates the form data with the new value.
   * @param e - The change event.
   * @example
   */
  const handleChange = (e: any) => {
    const { value } = e.target;
    console.log('value', e, value);
    setDropdownData(value);
  };

  return (
    <CcfBox className={styles.tableBlock}>
      <CcfBox>
        <CcfBox className={styles.tableHeaderTextBlock}>
          <CcfBox>{props.tableHeaderText}</CcfBox>
          {props.isSelectRequired && (
            <CcfBox style={{ marginLeft: '50px' }}>
              <Select
                id={'selectControl'}
                className={styles.dropdownButton}
                value={dropdownData}
                onChange={(e: any) => handleChange(e)}
              >
                {[
                  translate('last30days'),
                  translate('last60days'),
                  translate('last90days'),
                ].map((x: any) => (
                  <MenuItem
                    key={x}
                    value={x}
                    style={{ fontSize: '13px', color: '#2e2e2e' }}
                  >
                    {x}
                  </MenuItem>
                ))}
              </Select>
            </CcfBox>
          )}
        </CcfBox>
      </CcfBox>
      <CcfBox
        style={{
          height: 'inherit',
          backgroundColor: '#f2f7fa',
          overflowY: 'hidden',
        }}
        id={`agent_wem_dataGridContainer`}
      >
        {' '}
        <DataGrid
          classes={{ root: classes.root }}
          rows={props.rowData}
          columns={props.columns}
          rowHeight={40}
          getRowId={(row) => row?.id}
          pageSize={10}
          headerHeight={40}
          // autoHeight
          disableSelectionOnClick
          pagination
          rowsPerPageOptions={[5, 10, 25]}
          getRowClassName={(params: any) => `styledrows`}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              color: '#3F5C69',
              fontWeight: '600',
              fontSize: '12px',
              fontFamily: 'Open Sans',
            },
          }}
          components={{
            NoRowsOverlay: () => props?.noDataFound,
          }}
        />
      </CcfBox>
    </CcfBox>
  );
}
